import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    header: {
      display: 'block',
      padding: '1rem 0',
    },
    headerName: {
      marginBottom: '0.5rem',
      fontWeight: 'bold',
      display: 'block',
    },
    headerDisclaimer: {
      display: 'block',
      fontWeight: 'normal',
      color: theme.palette.warning.main,
    },
  };
});

export { useStyles };
